import React, { useState, useEffect } from "react";
import { ContentContainer } from "../../../components/layout";
import CellEditingTable from "./components/cell-editing-table";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery } from "@apollo/client";
import {
  CREATE_USER_TYPE,
  UPDATE_USER_TYPE,
  USER_TYPES,
} from "../../../constants/graphql/locker-user-types";
import {
  getUserTypeData,
  handleClearAllForms,
  handleOnAddUserTypeReducer,
  handleOnChangeAddedUserTypeReducer,
  handleOnDeleteUserTypeOnFormReducer,
  handleOnEditUserTypeReducer,
} from "../../../features/locker-user-types/locker-user-types-slice";
import {
  Button,
  LinearProgressBar,
  Modal,
  Table,
  Textarea,
  Textfield,
} from "../../../components/core";
import { Strings } from "../../../constants/strings";
import TotalRecords from "../../../components/core/total-records";
import { InputText } from "primereact/inputtext";
export default function LockerUserTypes() {
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const [showCancelSave, setshowCancelSave] = useState(false);
  // Utilities
  const dispatch = useDispatch();
  // Redux States
  const userTypeData = useSelector(
    (state) => state.lockerUserTypes.userTypeData
  );
  const addedUserTypeData = useSelector(
    (state) => state.lockerUserTypes.addedUserTypeData
  );
  // Graphql
  const userTypes = useQuery(USER_TYPES, {
    variables: {
      operatorId: operatorId,
    },
  });
  const [updateLockerUserType] = useMutation(UPDATE_USER_TYPE);
  const [createLockerUserType] = useMutation(CREATE_USER_TYPE);
  const [editedRows, setEditedRows] = useState(new Set());
  //Local States
  const [intialStateFlag, setInitialStateFlag] = React.useState(false);
  const [initialUserTypes, setInitialUserTypes] = React.useState();
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  const [tableUpdatingFlag, setTableUpdatingFlag] = React.useState(false);
  //Handle Changes
  const handleOnEditUserType = (rowId, newValue, field, rowData) => {
    dispatch(
      handleOnEditUserTypeReducer({
        rowId: rowId,
        newValue: newValue,
        field: field,
      })
    );
    console.log(rowId, newValue, field);
    setEditedRows((prevEditedRows) =>
      new Set(prevEditedRows).add({
        userTypeId: rowData["userTypeId"],
        userType: field == "userType" ? newValue : rowData["userType"],
        operatorId: operatorId,
        monthlyFee: field == "monthlyFee" ? newValue : rowData["monthlyFee"],
        description: field == "description" ? newValue : rowData["description"],
      })
    );
    setshowCancelSave(true);
  };

  useEffect(() => {
    console.log(editedRows);
  }, [editedRows]);

  const handleOnAddUserType = () => {
    dispatch(
      handleOnAddUserTypeReducer({
        operatorId: operatorId,
        userType: "",
        description: "",
        monthlyFee: "",
        sort: 1,
      })
    );
  };
  const handleOnChangeAddedUserType = (event) => {
    let { name, id, value } = event.target;
    const regex = /^\d*\.?\d{0,2}$/;
    if (name === "monthlyFee") {
      const floatValue = parseFloat(value);

      if ((regex.test(value) && floatValue <= 1000000000) || value === "") {
        dispatch(
          handleOnChangeAddedUserTypeReducer({
            name: name,
            id: id,
            value: value,
          })
        );
      }
    } else {
      dispatch(
        handleOnChangeAddedUserTypeReducer({
          name: name,
          id: id,
          value: value,
        })
      );
    }
  };

  // const handleOnDeleteUserTypeInForm = (index) => {
  // 	dispatch(handleOnDeleteUserTypeOnFormReducer(index));
  // };

  // what is this pls
  const handleSaveChanges = () => {
    let tempUserType = [...userTypeData];
    let tempAddedUserType = [...addedUserTypeData];

    console.log("helo");
    // Filter out lines where all fields are empty
    let filteredData = tempAddedUserType.filter(
      (x) =>
        !(x.userType === "" || x.userType === null) ||
        !(x.description === "" || x.description === null) ||
        !(x.monthlyFee === "" || x.monthlyFee === null)
    );

    // console.log(tempUserType);

    if (filteredData.length == 0) {
      setValidation({ open: false });
      return;
    }

    let combinedAddedAndEditedUserTypeData = editedRows.concat(filteredData);

    let filterDuplicateUserType = combinedAddedAndEditedUserTypeData.filter(
      (obj, index, self) =>
        self.findIndex(
          (o) =>
            o.userType.toLowerCase().replaceAll(" ", "") ===
            obj.userType.toLowerCase().replaceAll(" ", "")
        ) !== index
    );

    let filterEmptyValue = combinedAddedAndEditedUserTypeData.filter(
      (x) =>
        x.userType === "" ||
        x.userType === null ||
        // x.description === "" ||
        // x.description === null ||
        x.monthlyFee === "" ||
        x.monthlyFee === null
    );
    if (filterDuplicateUserType.length > 0 && filterEmptyValue.length <= 0) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title_duplicate,
        message: Strings.popup_error_message_duplicate,
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else if (filterEmptyValue.length > 0) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title_empty_field,
        message: Strings.popup_error_message_empty_field,
        open: true,
        actions: (
          <div className="grid grid-cols-1">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else {
      setValidation({ open: false });
      setTableUpdatingFlag(true);
      let tempUserTypeData = JSON.parse(JSON.stringify(userTypeData));
      userTypeData.forEach((element, index) => {
        tempUserTypeData[index].operatorId = operatorId;
        delete tempUserTypeData[index].__typename;
      });

      addedUserTypeData.forEach((element, index) => {
        createLockerUserType({ variables: element })
          .then((data) => {
            setTableUpdatingFlag(false);
          })
          .catch((e) => console.log(e));
      });
      updateLockerUserType({ variables: { userTypes: Array.from(editedRows) } })
        .then((data) => {
          setTableUpdatingFlag(false);
        })
        .catch((e) => console.log(e));
      setInitialUserTypes(combinedAddedAndEditedUserTypeData);
      dispatch(getUserTypeData(combinedAddedAndEditedUserTypeData));
      dispatch(handleClearAllForms());
      if (tempUserType.length > 0 && tempAddedUserType.length > 0) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
          // title: Strings.popup_success_title_default,
          message: "Successfully added and edited Locker User Type.",
          open: true,
          actions: (
            <div className="grid grid-cols-1">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2"}
              />
            </div>
          ),
        });
        window.location.reload();
      } else {
        if (tempAddedUserType.length > 0) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            // title: Strings.popup_success_title_default,
            message: "Successfully added Locker User Type.",
            open: true,
            actions: (
              <div className="grid grid-cols-1">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2"}
                />
              </div>
            ),
          });
        } else {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            // title: Strings.popup_success_title_default,
            message: "Successfully edited Locker User Type.",
            open: true,
            actions: (
              <div className="grid grid-cols-1">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2"}
                />
              </div>
            ),
          });
        }
      }
    }
  };
  console.log({ addedUserTypeData, editedRows });

  const handleCancelChanges = () => {
    setValidation({ open: false });
    dispatch(getUserTypeData(initialUserTypes));
    dispatch(handleClearAllForms());
    window.location.reload();
  };
  // Use Effects
  React.useEffect(() => {
    if (userTypes.data) {
      dispatch(getUserTypeData(userTypes.data.lockerUserTypes));
      setInitialStateFlag(true);
      if (!intialStateFlag) {
        setInitialUserTypes(userTypes.data.lockerUserTypes);
      }
    }
  }, [userTypes.data]);
  return (
    <ContentContainer containerTitle={"Locker User Types"}>
      <LinearProgressBar
        open={tableUpdatingFlag}
        label="User type table is updating..."
      />
      {accessPermission.lockerUserType === 1 ||
      accessPermission.lockerUserType === "1" ? (
        <>
          <TotalRecords count={userTypeData.length} />
          <Table
            headers={[
              {
                header_key: "userType",
                header_name: "Locker User Type",
              },
              { header_key: "description", header_name: "Description" },
              { header_key: "monthlyFee", header_name: "Monthly Fee" },
            ]}
            items={userTypeData}
          />
        </>
      ) : (
        <>
          <TotalRecords count={userTypeData.length} />
          <CellEditingTable
            data={userTypeData}
            headers={[
              {
                field: "userType",
                header: "Locker User Type",
                type: "textfield",
              },
              { field: "description", header: "Description", type: "textarea" },
              {
                field: "monthlyFee",
                header: "Monthly Fee",
                type: "numberfield",
              },
            ]}
            handleOnCellEditComplete={handleOnEditUserType}
            primaryKey="userTypeId"
          />
        </>
      )}

      <Button
        value={"Add form"}
        className={"p-2 mx-auto my-4"}
        onClick={handleOnAddUserType}
        disabled={
          accessPermission.lockerUserType === 1 ||
          accessPermission.lockerUserType === "1"
        }
      />
      {addedUserTypeData.map((data, key) => {
        return (
          <div className="flex gap-2" key={key}>
            <div className="grid grid-cols-3 gap-2 my-4 w-full shadow-lg">
              <Textfield
                classNameParent={"my-auto"}
                placeholder={"User Type"}
                onChange={handleOnChangeAddedUserType}
                name="userType"
                id={key}
                value={data.userType}
              />
              <Textarea
                placeholder="Description"
                onChange={handleOnChangeAddedUserType}
                name="description"
                id={key}
                value={data.description}
              />

              {/* <Textfield
								key={"int"}
								className={
									"my-auto w-full h-10 border-2 focus:outline-yellow-400 rounded-md p-1"
								}
								placeholder={"Monthly Fee"}
								onChange={handleOnChangeAddedUserType}
								name="monthlyFee"
								id={key}
								value={data.monthlyFee}
							/> */}
              <InputText
                keyfilter={"int"}
                className={
                  "my-auto w-full h-10 border-2 focus:outline-yellow-400 rounded-md p-1"
                }
                placeholder={"Monthly Fee"}
                onChange={handleOnChangeAddedUserType}
                name="monthlyFee"
                id={key}
                value={data.monthlyFee}
              />
            </div>
            {/* <i
              className="fas fa-trash text-red-500 my-auto cursor-pointer"
              onClick={() => handleOnDeleteUserTypeInForm(key)}
            ></i> */}
          </div>
        );
      })}
      <hr></hr>
      {showCancelSave && (
        <div className="w-1/3 grid grid-cols-2 gap-2 my-2">
          <Button
            value={"Cancel"}
            className={"p-2"}
            disabled={
              accessPermission.lockerUserType === 1 ||
              accessPermission.lockerUserType === "1"
            }
            onClick={() => {
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: Strings.popup_confirm_cancel_title,
                message: Strings.popup_confirm_cancel_massage,
                open: true,
                actions: (
                  <div className="grid grid-cols-2 gap-2">
                    <Button
                      onClick={() => setValidation({ open: false })}
                      value={"No"}
                      className={"p-2"}
                    />
                    <Button
                      onClick={handleCancelChanges}
                      value={"Yes"}
                      className={"p-2"}
                    />
                  </div>
                ),
              });
            }}
          />
          <Button
            value={"Save"}
            className={"p-2"}
            disabled={
              accessPermission.lockerUserType === 1 ||
              accessPermission.lockerUserType === "1"
            }
            onClick={() => {
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                title: Strings.popup_confirm_save_title,
                message: Strings.popup_confirm_save_massage,
                open: true,
                actions: (
                  <div className="grid grid-cols-2 gap-2">
                    <Button
                      onClick={() => setValidation({ open: false })}
                      value={"No"}
                      className={"p-2"}
                    />
                    <Button
                      onClick={handleSaveChanges}
                      value={"Yes"}
                      className={"p-2"}
                      disabled={
                        accessPermission.lockerUserType === 1 ||
                        accessPermission.lockerUserType === "1"
                      }
                    />
                  </div>
                ),
              });
            }}
          />
        </div>
      )}

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
}
